import {
    AddNew
} from 'one-model-local';

import {
    Source
} from 'one-model-local';

import {
    formatPhoneNumber
} from '../../subject/src/transform';

import {format} from 'one-util-date';

/**
 * 
 * @param response constains the response of caller details fetched from db
 */

export const TransformSetCaller = (response: any, request: any, context: any) => {
    let addnew: AddNew = {
        id: undefined,
        name: undefined,
        phone: undefined,
        address: undefined,
        department: undefined,
        typeName: undefined,
        subTypeName: undefined,
        email: undefined,
        dob: undefined,
    };
    let addnewresult: any = {
        addnewdata: addnew,
        error: undefined

    }
    const { log } = context;
    log.debug("on-epic", "AddNew transformation entered", response);
    // TODO:verify backend team check for errors
    if (response && (response.status >= 400 || response.type == "error")) {
        addnewresult.error = response;
    }

    if (response
        && response.length > 0) {
        addnew.id = response[0].uid;
        addnew.name = request?.name;
        addnew.phone = request?.phone;
        addnew.address = request?.address;
        addnew.typeName = request?.typeName;
        addnew.subTypeName = request?.subTypeName;
        addnew.email = request?.email;
        addnew.department = request?.department;
        addnew.dob = format(request?.dateofbirth, "YYYY-MM-DD");
    }

    addnewresult.addnewdata = addnew;
    log.debug("on-epic", "AddNew transformed data", addnewresult);
    return addnewresult;
}

/**
 * 
 * @param response contains the setcallerdetails response
 * @param context contains settings json file etc ..
 */
export const TransformSetCallerDetailsResponse = (response: AddNew, context: any) => {
    let sourcedata: Source[] = [];
    let source: Source = {
        id: undefined,
        mrn: undefined,
        dob: undefined,
        gender: undefined,
        contact: undefined,
        address: undefined,
        lastname: undefined,
        firstname: undefined,
        middlename: undefined
    };
    const { log } = context;
    log.debug("on-epic", "TransformSetCallerDetailsResponse entered", response);
    if (response && response.id && response.id.length > 0) {
        source.id = response.id;
        source.initials = response.name?.charAt(0);
        source.firstname = response.name;
        source.address = response.address;
        source.contact = response.phone;
        source.typename = response.typeName;
        source.subtypename = response.subTypeName;
        source.email = response.email;
        source.dob = response.dob;
        const formattednumber = formatPhoneNumber(response.phone);
        source.contact_formatted = formattednumber === "" ? response.phone: formattednumber;
        sourcedata.push(source);
    }
    log.debug("on-epic", "TransformSetCallerDetailsResponse transformed data", sourcedata);
    return sourcedata;
}